'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;
var _extends2 = require('babel-runtime/helpers/extends');
var _extends3 = _interopRequireDefault(_extends2);
var _ramda = require('ramda');
var R = _interopRequireWildcard(_ramda);
function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};
    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
      }
    }
    newObj.default = obj;
    return newObj;
  }
}
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function computors(target) {
  target.computors = (0, _extends3.default)({}, target.computors, {
    /*
      by placing focused datapoints at the end, insure them being rendered last, and so rendered over regular ones.
      baseline shoulbe on top of highlights
    */
    data: function data(_data) {
      return R.pipe(R.head, R.propOr([], 'datapoints'), R.sortWith([R.ascend(target.accessors.baselineIndex), R.ascend(target.accessors.highlightIndex)]))(_data);
    }
  });
}
exports.default = computors;